import { render, staticRenderFns } from "./ServerStatus.vue?vue&type=template&id=20426e98&scoped=true"
import script from "./ServerStatus.vue?vue&type=script&lang=js"
export * from "./ServerStatus.vue?vue&type=script&lang=js"
import style0 from "./ServerStatus.vue?vue&type=style&index=0&id=20426e98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20426e98",
  null
  
)

export default component.exports